let is_prod=true;


const servers=is_prod ?
 "https://zoommeetingappbackend.onrender.com":

  "http://localhost:8000"
   

export default servers;